
export const CATEGORIES_COLUMNS = [
    "Name", "Action"
];
export const SUB_CATEGORIES_COLUMNS = [
    "Name", "Category", "Action"
];